import { StringData } from "../../core/StringData";

export class StringScrollbarHorizontal {
  private scrollbar: any;
  private thumb: any;
  private isDragging = false;
  private onScrollTo: (position: number) => void;
  private startY: number = 0;
  private startScrollPosition: number = 0;
  data: StringData;

  constructor(
    data: StringData,
    scrollbar: any,
    thumb: any,
    onScrollTo: (position: number) => void,
  ) {
    this.data = data;
    this.scrollbar = scrollbar;
    this.thumb = thumb;
    this.onScrollTo = onScrollTo;
  }

  onResize(): void {
    const contentWidth = this.data.viewport.contentWidth;
    const visibleWidth = this.data.viewport.windowWidth;

    const thumbSize = (visibleWidth / contentWidth) * visibleWidth;
    this.thumb.style.setProperty('--size', thumbSize + 'px');

    if (contentWidth <= visibleWidth) {
      this.scrollbar.classList.add('-hide');
    } else {
      this.scrollbar.classList.remove('-hide');
    }
  }

  updateThumb() {
    const contentWidth = this.data.viewport.contentWidth;
    const visibleWidth = this.data.viewport.windowWidth;
    this.thumb.style.setProperty('--position', `${(this.data.scroll.current / contentWidth) * visibleWidth + 'px'}`);
  }

  mouseDownEvent(e: MouseEvent) {
    this.startY = e.clientY;
    this.startScrollPosition = this.data.scroll.current;
  }

  mouseMoveEvent(e: MouseEvent) {
    const deltaY = e.clientY - this.startY;
    const newScrollPosition = this.startScrollPosition + (deltaY / this.data.viewport.windowWidth) * this.data.viewport.contentWidth;
    this.data.scroll.current = newScrollPosition;
    this.data.scroll.target = newScrollPosition;
    this.onScrollTo(newScrollPosition);
    this.updateThumb();
  }
}
